export default __webpack_public_path__ + "static/media/clock_open.c97f05c8.svg";